import * as ROUTES from 'src/api/routes';
import request from './utils';

export async function getSurveyTemplates() {
    const response = await request({ ...ROUTES.ADMIN_GET_SURVEY_TEMPLATES });

    return { result: response.data || [], count: response.data.length || 0 };
}
